import type { OperationGuideKey } from './types';

/** 仅用于路由校验的轻量 key 表，勿在此引入 guides / modal */
export const OPERATION_GUIDE_KEYS: readonly OperationGuideKey[] = [
  'collect',
  'draw',
  'product',
  'shoplist',
  'order',
  'tiktok',
] as const;

const GUIDE_KEY_SET = new Set<string>(OPERATION_GUIDE_KEYS);

export function isOperationGuideKey(key: string): key is OperationGuideKey {
  return GUIDE_KEY_SET.has(key);
}
